"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPreferenceAddEventType = exports.SettingsPreferenceType = void 0;
const t = __importStar(require("io-ts"));
const utils_1 = require("../../utils");
var PreferenceTypeEnum;
(function (PreferenceTypeEnum) {
    PreferenceTypeEnum["WEB_EXT_POSITION"] = "WEB_EXT_POSITION";
    PreferenceTypeEnum["WEB_EXT_POSITION_BY_HOSTNAME"] = "WEB_EXT_POSITION_BY_HOSTNAME";
    PreferenceTypeEnum["ARTICLE_COPY_PASTE_SHORTCUT"] = "ARTICLE_COPY_PASTE_SHORTCUT";
    PreferenceTypeEnum["ANSWER_COPY_PASTE_SHORTCUT"] = "ANSWER_COPY_PASTE_SHORTCUT";
    PreferenceTypeEnum["MODAL_CLOSURE_SHORTCUT"] = "MODAL_CLOSURE_SHORTCUT";
    PreferenceTypeEnum["FORCING_SHORTCUT"] = "FORCING_SHORTCUT";
    PreferenceTypeEnum["RESET_NAVIGATION_PATH_AT_OPENING"] = "RESET_NAVIGATION_PATH_AT_OPENING";
    PreferenceTypeEnum["DISPLAY_FULL_TITLE"] = "DISPLAY_FULL_TITLE";
    PreferenceTypeEnum["DISPLAY_ARTICLE_IN_MAIN_FRAME"] = "DISPLAY_ARTICLE_IN_MAIN_FRAME";
    PreferenceTypeEnum["SIDEBAR_CUSTOM_WIDTH"] = "SIDEBAR_CUSTOM_WIDTH";
    PreferenceTypeEnum["WEB_EXT_URL_BLACKLIST"] = "WEB_EXT_URL_BLACKLIST";
    PreferenceTypeEnum["CONTENT_FONT_SIZE"] = "CONTENT_FONT_SIZE";
})(PreferenceTypeEnum || (PreferenceTypeEnum = {}));
exports.SettingsPreferenceType = t.intersection([
    t.type({
        type: (0, utils_1.tDotEnum)(PreferenceTypeEnum),
    }),
    t.partial({
        value: t.string,
    }),
]);
exports.SettingsPreferenceAddEventType = t.intersection([
    t.type({
        preference: exports.SettingsPreferenceType,
    }),
    t.partial({
        location: t.string, // chrome_ext
    }),
]);
